import Deleted from "../../assets/images/deleted.png";
import TotalOrders from "../../assets/images/orders.png";
import Approved from "../../assets/images/approved.png";
import Pending from "../../assets/images/pending.png";
import Contractors from "../../assets/images/contractors.png";
import Logistics from "../../assets/images/logistics.png";
import Rmx from "../../assets/images/rmx.png";
const Images = {
  Logo: require("../../assets/images/logo.png"),
  ArrowBack: require("../../assets/images/icons/arrow_back.png"),
};

export default Images;

export { Deleted, TotalOrders, Approved, Pending, Contractors, Logistics, Rmx };
